import { useNavigate, Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useAutoFocus } from "@/hooks/useAutoFocus";

/** Info e crediti — pagina informativa semplice, coerente col branding FOCUSTAP. */
export default function Info() {
  const navigate = useNavigate();
  const headingRef = useAutoFocus();

  return (
    <main className="screen" data-testid="info-screen">
      <div className="screen__header">
        <button
          type="button"
          className="back-btn"
          data-testid="info-back-button"
          onClick={() => navigate("/")}
          aria-label="Torna alla schermata principale"
        >
          <ChevronLeft size={16} strokeWidth={2.5} aria-hidden="true" />
          Indietro
        </button>
        <h1 className="screen__title" tabIndex={-1} ref={headingRef}>
          Info e crediti
        </h1>
      </div>

      <p className="doc__p">
        <strong>FOCUSTAP</strong> è un gioco di attenzione, memoria e riflessi: leggi o ascolti una
        richiesta e rispondi con il numero di tocchi corretto entro 6 secondi.
      </p>

      <h2 className="section-label">Come è fatto</h2>
      <p className="doc__p">
        Web app realizzata in React. Nessun account e nessun server di gioco: tutto funziona
        direttamente nel tuo browser.
      </p>

      <h2 className="section-label">I tuoi dati</h2>
      <p className="doc__p">
        Record e preferenze sono salvati solo sul tuo dispositivo. Maggiori dettagli nella pagina{" "}
        <Link to="/privacy" className="doc__link" data-testid="info-privacy-link">
          Privacy e Cookie
        </Link>
        .
      </p>

      <h2 className="section-label">Crediti</h2>
      <p className="doc__p">
        Caratteri tipografici <strong>Space Grotesk</strong> e <strong>Space Mono</strong>. La voce
        della modalità Accessibilità usa la sintesi vocale del browser (Web Speech API).
      </p>

      <h2 className="section-label">Scopri di più</h2>
      <p className="doc__p">
        <Link to="/come-si-gioca" className="doc__link" data-testid="info-how-to-play-link">
          Come si gioca
        </Link>{" "}
        ·{" "}
        <Link to="/accessibilita" className="doc__link" data-testid="info-accessibility-link">
          Accessibilità
        </Link>
      </p>

      <p className="doc__p" data-testid="info-copyright">© 2026 FOCUSTAP</p>
    </main>
  );
}
